import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-create-banner-dialog',
  templateUrl: './create-banner-dialog.component.html',
  styleUrls: ['./create-banner-dialog.component.scss']
})
export class CreateBannerDialogComponent implements OnInit {

  @ViewChild('inputFiles', {static: true}) inputFiles: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<CreateBannerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      typeId: number,
      order: number,
      img: string,
      img64: any,
      title: string,
      subTitle: string,
      subTitle2: string,
      nameButton1: string,
      urlButton1: string
    }) {
  }

  ngOnInit(): void {
  }

  onDismiss() {
    this.dialogRef.close();
  }

  handleUpload(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      this.data.img64 = reader.result;
      this.data.img = event.target.files[0].type.replace('/', '.');
    };
  }

  openUploadFiles() {
    const el: HTMLElement = this.inputFiles.nativeElement as HTMLElement;
    el.click();
  }

}
